import { useState } from 'react';
import { PageFilterCard } from 'components/FilterCard';
import { AMENITY_ADAPTER, APARTMENT_ADAPTER } from 'consts';

export const filterList = {
  'can-ho': {
    id: 'can-ho',
    label: 'Apartments',
    floors: {
      label: 'Typical floors',
      options: ['5-22', '23-25', '26-28'],
    },
    types: {
      label: 'Unit type',
      options: [
        // 'studio',
        '1pn',
        '1pn-plus',
        '2pn-1wc',
        '2pn-2wc',
        '3pn',
        '3pn-dualkey',
      ],
    },
  },
  'tien-ich': {
    id: 'tien-ich',
    label: 'Amenities',
    categories: {
      t1: {
        id: 't1',
        label: 'T1 Amenities',
        options: [
          {
            label: 'shophouse',
            id: 'shophouse-b7c94848',
          },
          {
            label: 'pool',
            id: 'swimming-pool-69e0cb67',
          },
          {
            label: 'playground',
            id: 'sports-court-653bdcb8',
          },
        ],
      },
    },
  },
};

export const Filter = ({ filter, setFilter, onSelectScene }) => {
  const [categoryType, setCategoryType] = useState('t1');
  const { type } = filter;

  const currentFilter = filterList[type];

  const handleChangeFloor = (type) => {
    setFilter((prev) => ({ ...prev, floor: type }));
  };

  const handleChangeApartment = (type) => {
    setFilter((prev) => ({ ...prev, apartmentType: type }));
  };

  const handleChangeUsageArea = (value) => {
    setFilter((prev) => ({ ...prev, usageArea: value }));
  };

  const handleChangeType = (type) => {
    setFilter((prev) => ({ ...prev, type }));
  };

  const handleResetAll = () => {
    setFilter((prev) => ({
      ...prev,
      apartmentType: '',
      floor: '',
      usageArea: 100,
    }));
  };

  const contentWithProps = (
    <Content
      type={type}
      filter={filter}
      currentFilter={currentFilter}
      setUsageArea={handleChangeUsageArea}
      categoryType={categoryType}
      setCategoryType={setCategoryType}
      setFloorType={handleChangeFloor}
      setApartmentType={handleChangeApartment}
      setType={handleChangeType}
      onSelectScene={onSelectScene}
      resetAll={handleResetAll}
    />
  );

  return (
    <PageFilterCard className="so-do-tong-the-filter-card">
      {contentWithProps}
    </PageFilterCard>
  );
};

const Content = ({
  type,
  currentFilter,
  setUsageArea,
  categoryType,
  setCategoryType,
  setFloorType,
  setApartmentType,
  filter,
  setType,
  resetAll,
  onSelectScene,
}) => {
  const { floor: floorType, apartmentType, usageArea } = filter;
  const onChangeFloorType = (e) => {
    const type = e.target.dataset.option;
    // Toggle: if clicking the same filter, clear it
    setFloorType(floorType === type ? '' : type);
  };

  const onChangeApartmentType = (e) => {
    const type = e.target.dataset.option;
    // Toggle: if clicking the same filter, clear it
    setApartmentType(apartmentType === type ? '' : type);
  };

  return (
    <div className="filter-container">
      <div className="filter-tab">
        <div
          className={`tab-item ${type === 'can-ho' ? 'active' : ''}`}
          onClick={() => setType('can-ho')}
        >
          Apartments
        </div>
        <div
          className={`tab-item ${type === 'tien-ich' ? 'active' : ''}`}
          onClick={() => setType('tien-ich')}
        >
          Amenities
        </div>
      </div>

      {/* Can ho filter body */}
      {currentFilter.id === 'can-ho' && (
        <div className="filter-body can-ho">
          <div className="filter-wrapper">
            <div className="filter-section">
              <p className="section-label">{currentFilter.floors.label}</p>
              <div className="section-options">
                {currentFilter.floors.options.map((option) => (
                  <button
                    data-option={option}
                    className={`option-item ${
                      floorType === option ? 'active' : ''
                    }`}
                    key={option}
                    onClick={onChangeFloorType}
                  >
                    {option}
                  </button>
                ))}
              </div>
            </div>
            <div className="filter-section">
              <p className="section-label">{currentFilter.types.label}</p>
              <div className="section-options">
                {currentFilter.types.options.map((option) => (
                  <div
                    data-option={option}
                    className={`option-item ${
                      apartmentType === option ? 'active' : ''
                    }`}
                    key={option}
                    onClick={onChangeApartmentType}
                  >
                    {APARTMENT_ADAPTER[option].abbreviation}
                  </div>
                ))}
              </div>
            </div>
            <div className="filter-section">
              <p className="section-label">Net area</p>
              <div className="range-slider">
                <input
                  type="range"
                  min="30"
                  max="100"
                  step={10}
                  value={usageArea}
                  onChange={(e) => setUsageArea(Number(e.target.value))}
                />
                <span>Less than {usageArea}m2</span>
              </div>
            </div>
          </div>
          <button className="reset-btn" onClick={resetAll}>
            Reset
          </button>
        </div>
      )}

      {/* Tien ich filter body */}
      {currentFilter.id === 'tien-ich' && (
        <div className="filter-body tien-ich">
          {/* <div className="body-headers">
            {Object.values(currentFilter.categories).map((category) => (
              <button
                className={`header-item ${
                  category.id === categoryType ? 'active' : ''
                }`}
                key={category.id}
                onClick={() => setCategoryType(category.id)}
              >
                {category.label}
              </button>
            ))}
          </div> */}
          <div className="body-options">
            {currentFilter.categories[categoryType].options.map((option) => (
              <button
                className="option-item"
                key={option.id}
                onClick={() => {
                  onSelectScene(AMENITY_ADAPTER[option.label].scene, true);
                  window.dispatchEvent(new Event('close-side-drawer'));
                }}
              >
                {AMENITY_ADAPTER[option.label].label}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
